import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=7e708ccd&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.scss?vue&type=style&index=0&id=7e708ccd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e708ccd",
  null
  
)

export default component.exports